import * as React from 'react'
import Grid from '@material-ui/core/Grid'
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from 'react-stripe-elements'

import StripeElementWrapper from './StripeElementWrapper'

class StripeCardSection extends React.PureComponent {
  public render() {
    return (
      <Grid container>
        <Grid item xs={12}>
          <StripeElementWrapper
            label="Card Number"
            component={CardNumberElement}
          />
        </Grid>
        <Grid item xs={7}>
          <StripeElementWrapper
            label="Expiry (MM / YY)"
            component={CardExpiryElement}
          />
        </Grid>
        <Grid item xs={5}>
          <StripeElementWrapper
            label="CVC"
            helpText="The security code on the back of the card"
            component={CardCVCElement}
          />
        </Grid>
      </Grid>
    )
  }
}

export default StripeCardSection



// WEBPACK FOOTER //
// ./src/components/stripe-mui/StripeCardSection.tsx